module.exports = __webpack_public_path__ + "static/img/active_vip_03.2f6b4d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_03.jpg
// module id = CH6j
// module chunks = 0